import showCard from "./show_card/show_card";
import techMap from "./tech_map/tech_map";

export default {
  show_card: showCard,
  tech_map: techMap,
};
